var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("推荐位管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: { content: _vm.title },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      "label-position": "right",
                      model: _vm.ruleForm1,
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入标题" },
                          model: {
                            value: _vm.ruleForm1.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "name", $$v)
                            },
                            expression: "ruleForm1.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "副标题", prop: "" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入副标题" },
                          model: {
                            value: _vm.ruleForm1.name1,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "name1", $$v)
                            },
                            expression: "ruleForm1.name1",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "适配端", prop: "terminal" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.ruleForm1.terminal,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "terminal", $$v)
                              },
                              expression: "ruleForm1.terminal",
                            },
                          },
                          _vm._l(_vm.configList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.val, value: item.key },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "类型", prop: "type" } },
                      [
                        _c("el-cascader", {
                          staticStyle: { "margin-right": "auto" },
                          attrs: {
                            props: _vm.cateProps,
                            "show-all-levels": false,
                            options: _vm.cageryList,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.selectData,
                            callback: function ($$v) {
                              _vm.selectData = $$v
                            },
                            expression: "selectData",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                        attrs: { label: "是否强制观看", prop: "sort" },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleForm1.display,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "display", $$v)
                              },
                              expression: "ruleForm1.display",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("否"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "关闭方式", prop: "terminal" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择推荐位关闭方式" },
                            model: {
                              value: _vm.ruleForm1.closeType,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "closeType", $$v)
                              },
                              expression: "ruleForm1.closeType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "不关闭", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "查看后关闭", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "手动关闭", value: "2" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "倒计时", prop: "" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入倒计时" },
                              model: {
                                value: _vm.ruleForm1.num,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "num", $$v)
                                },
                                expression: "ruleForm1.num",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "red",
                                  "font-size": "12px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                *关闭倒计时最小可设置3秒，并且在倒计时>0时不管关闭方式都会执行倒计时关闭\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "跳转地址", prop: "" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入跳转地址" },
                          model: {
                            value: _vm.ruleForm1.url,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "url", $$v)
                            },
                            expression: "ruleForm1.url",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "上传图片", prop: "img" } },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "avatar-uploader",
                            staticStyle: { "margin-right": "auto" },
                            attrs: {
                              "list-type": "picture-card",
                              action: _vm.uploadUrl,
                              headers: _vm.deader,
                              "on-success": _vm.handleAvatarSuccess,
                              "on-remove": _vm.handleRemove,
                              multiple: true,
                              "file-list": _vm.ruleForm1.img,
                              limit: 1,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "0 0 20px 80px",
                          "font-size": "12px",
                          color: "red",
                        },
                      },
                      [_vm._v("\n            尺寸：640×800\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "阅读数", prop: "templateNo" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入阅读数" },
                          model: {
                            value: _vm.ruleForm1.templateNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "templateNo", $$v)
                            },
                            expression: "ruleForm1.templateNo",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            staticStyle: { "margin-left": "16px" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.getNum()
                              },
                            },
                          },
                          [_vm._v("生成随机数")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "短简介", prop: "memo" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入短简介",
                          },
                          model: {
                            value: _vm.ruleForm1.memo,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "memo", $$v)
                            },
                            expression: "ruleForm1.memo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "简介", prop: "memo1" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入简介",
                          },
                          model: {
                            value: _vm.ruleForm1.memo1,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "memo1", $$v)
                            },
                            expression: "ruleForm1.memo1",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "50px" },
                            on: {
                              click: function ($event) {
                                return _vm.resetForm1("ruleForm")
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }